
import MaximizeCircle from "../../../assets/filled/MaximizeCircle.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MaximizeCircleIcon({ className, dataTestid = "MaximizeCircleIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <MaximizeCircle data-testid={dataTestid} className={classes} {...rest} />
  );
}
